module.exports = __webpack_public_path__ + "img/parachenian.394453ca.jpg";